import { WebError } from "@hybird/core/error";
import { deviceError } from "@hybird/device/deviceError";

class DeviceType {
  static a = 1;
  static aplus = 2;
  static simple = 3;
  static aplusJg = 4;
  static seal = 5;
  static a_smart = 10;
}

class Config {

  onConnect;

  onConnected;

  onReconnect;

  onError;

  deviceType = 1;

  _gps = {
    "lon": undefined, "lat": undefined
  };

  _blue = {
    name: undefined,
    mac: undefined,
    serviceUUIDs: ["0000ffe0-0000-1000-8000-00805f9b34fb", "0000fff1-0000-1000-8000-00805f9b34fb", "0000180a-0000-1000-8000-00805f9b34fb"],
    characteristicUUIDs: ["0000ffe1-0000-1000-8000-00805f9b34fb", "0000fff2-0000-1000-8000-00805f9b34fb", "00009999-0000-1000-8000-00805f9b34fb"],
    aplus: {
      serviceUUIDs: ["0000180a-0000-1000-8000-00805f9b34fb"],
      characteristicUUIDs: ["00009999-0000-1000-8000-00805f9b34fb"]
    },
    simple: {
      serviceUUIDs: ["0000fff1-0000-1000-8000-00805f9b34fb"],
      characteristicUUIDs: ["0000fff2-0000-1000-8000-00805f9b34fb"]
    },
    a: {
      serviceUUIDs: ["0000ffe0-0000-1000-8000-00805f9b34fb"],
      characteristicUUIDs: ["0000ffe1-0000-1000-8000-00805f9b34fb"]
    },
    aplusJg: {
      serviceUUIDs: ["0000180a-0000-1000-8000-00805f9b34fb"],
      characteristicUUIDs: {
        "00009999-0000-1000-8000-00805f9b34fb": "write",
        "dfd4416e-1810-47f7-8248-eb8be3dc47f9": "read"
      }
    },
    aSmart: {
      serviceUUIDs: ["0000180a-0000-1000-8000-00805f9b34fb"],
      characteristicUUIDs: {
        "00009999-0000-1000-8000-00805f9b34fb": "write",
        "dfd4416e-1810-47f7-8248-eb8be3dc47f9": "read"
      }
    },
    tureOn: async () => {
      return new Promise((resolve, reject) => {
        console.log("tureOn");
        resolve();
        // reject(deviceError.NOT_OPEN_BLUETOOTH);
      });
    }
  };

  /**
   *
   * @type {IClientOptions | {url: String}}
   */
  _mqtt = {
    clientId: undefined, username: undefined, password: undefined,
    /**
     *  以下使用mqtt
     *   'wss'
     *   'ws'
     *   'mqtt'
     *   'mqtts'
     *   'tcp'
     *   'ssl'
     *   'wx'
     *   'wxs'
     *   'ali'
     *   'alis'
     *
     *  以下使用自建websocket
     *   'netty'
     *   'nettys'
     *
     * @type{string}
     */
    url: undefined, mqttUrl: undefined, keepalive: 5, clean: true
  };

  _serial = {
    baudRate: 115200,
    bufferSize: 1024,   // 读写缓存，默认255
    dataBits: 8,       // 数据位，默认8
    flowControl: "none", // 流控制，默认无
    parity: "none",      // 校验，默认无
    stopBits: 1,       // 停止位，默认1
    usbProductId: 42151,
    usbVendorId: 1317,
    requestPort: (usbDevices) => {
      console.log("requestPort", JSON.stringify(usbDevices));
      if (usbDevices && usbDevices.length > 0) {
        return usbDevices[0].address;
      } else {
        throw WebError.code(deviceError.NOT_CONNECT_DEVICE);
      }
    }
  }

  _websocket = {};

  address = ""

  get gps() {
    return this._gps;
  }

  set gps(params) {
    Object.assign(this._gps, params);
  }

  get blue() {
    return this._blue;
  }

  set blue(params) {
    Object.assign(this._blue, params);
  }

  get serial() {
    return this._serial;
  }

  set serial(params) {
    Object.assign(this._serial, params);
  }

  get websocket() {
    return this._websocket;
  }

  set websocket(params) {
    Object.assign(this._websocket, params);
  }

  get mqtt() {
    return this._mqtt;
  }

  set mqtt(params) {
    Object.assign(this._mqtt, params);
  }

  timeout = 10;
}

class ConfigInfo {

  _config = new Config();

  /**
   *
   * @param config{Config}
   */
  set config(config) {
    if (config) {
      Object.assign(this._config, config);
    }
  }

  get config() {
    return this._config;
  }
}


const configInfo = new ConfigInfo();
const config = configInfo._config;

/**
 *
 * @param deviceInfo{DeviceInfo}
 * @param conf{Config}
 */
function setConfig(deviceInfo, conf) {
  const defaultConfig = new Config();
  Object.assign(defaultConfig, config);

  defaultConfig.mqtt.clientId = deviceInfo.sessionId;
  defaultConfig.mqtt.username = deviceInfo.userId.toString();
  defaultConfig.mqtt.password = deviceInfo.sessionId;
  defaultConfig.blue.name = deviceInfo.number;
  defaultConfig.serial.name = deviceInfo.number;

  if (deviceInfo.modelType === DeviceType.a) {
    defaultConfig.blue.serviceUUIDs = config.blue.a.serviceUUIDs;
    defaultConfig.blue.characteristicUUIDs = config.blue.a.characteristicUUIDs;
  } else if (deviceInfo.modelType === DeviceType.aplus) {
    defaultConfig.blue.serviceUUIDs = config.blue.aplus.serviceUUIDs;
    defaultConfig.blue.characteristicUUIDs = config.blue.aplus.characteristicUUIDs;
    defaultConfig.serial.usbProductId = 25
    defaultConfig.serial.usbVendorId = 8711
  } else if (deviceInfo.modelType === DeviceType.simple) {
    defaultConfig.blue.serviceUUIDs = config.blue.simple.serviceUUIDs;
    defaultConfig.blue.characteristicUUIDs = config.blue.simple.characteristicUUIDs;
  } else if (deviceInfo.modelType === DeviceType.aplusJg) {
    defaultConfig.blue.serviceUUIDs = config.blue.aplusJg.serviceUUIDs;
    defaultConfig.blue.characteristicUUIDs = config.blue.aplusJg.characteristicUUIDs;
    defaultConfig.serial.usbProductId = 42151
    defaultConfig.serial.usbVendorId = 1317
  } else if (deviceInfo.modelType === DeviceType.a_smart) {
    defaultConfig.blue.serviceUUIDs = config.blue.aSmart.serviceUUIDs;
    defaultConfig.blue.characteristicUUIDs = config.blue.aSmart.characteristicUUIDs;
    defaultConfig.serial.usbProductId = 25
    defaultConfig.serial.usbVendorId = 8711
  }

  Object.assign(defaultConfig, conf);
  return defaultConfig;
}

class DeviceInfo {
  /**
   * operationId
   * @type{String}
   */
  operationId;
  staffId;
  userName;
  /**
   * userId
   * @type{Number}
   */
  userId;
  /**
   * sessionId
   * @type{String}
   */
  sessionId;
  /**
   * @type{String}
   */
  deviceSecret;
  /**
   * 文件id
   * @type{Number}
   */
  documentId;
  /**
   * 盖印方式 1、常规，2、远程，3、连续，4、认证模式
   * @type{Number}
   */
  remote;
  /**
   * 印章表id
   * @type{Number}
   */
  sealId;
  /**
   * 印章名称
   * @type{String}
   */
  sealName;
  /**
   * 设备编号
   * @type{String}
   */
  number;
  /**
   * 指纹标识位
   * @type{Number[]}
   */
  position;


  /**
   * 设备是否在线 0、离线 1、在线
   * @type{Number}
   */
  deviceState;

  /**
   * 当前印章申请次数
   * @type{Number}
   */
  applicationNumber;

  /**
   * 申请印章补盖次数
   * @type{Number}
   */
  reApplicationNumber;

  /**
   * 当前印章剩余次数
   * @type{Number}
   */
  leftTimes;

  /**
   * 印章状态 不可用0，待用印1，用印中2，用印完成3
   * @type{Number}
   */
  status;

  /**
   * 设备型号 1、A款 2、APlus 3、简易款 4、印章台 5、印章
   * @type{Number}
   */
  modelType;

  /**
   * 设备型号
   * @type{String}
   */
  model;

  /**
   * 是否有wifi功能
   */
  wifi;

  /**
   * 1: 蓝牙  2:mqtt, 3: 自动
   * @type{Number}
   */
  connectType = 3;

  /**
   * 设置自动的连接顺序
   * @type{[Number]} 默认 [4, 2, 1]
   */
  connectTypes;

  set connectMode(mode) {
    this.connectType = mode;
  }

  get connectMode() {
    return this.connectType;
  }

  /**
   * 用印前拍照 1开启 2关闭
   * @type{Number}
   */
  _beforeSealPhoto = 2;

  /**
   * 用印后自动抓拍 1开启 2关闭
   * @type{Number}
   */
  afterSealSnap = 2;

  /**
   * 自动抓拍间隔 0.5 1.0 1.5 2.0
   * @type{Number}
   */
  snapInterval = 1;

  /**
   * 自动抓拍间隔 0.5 1.0 1.5 2.0
   * @type{Number}
   */
  snapIntervalTx = 1;

  /**
   * 用印后自动抓拍 1开启 2关闭
   * @type{Number}
   */
  afterSealSnapTx = 2;

  /**
   * 该文件是否开启ocr默认false
   * @type{Boolean}
   */
  isOpenOcr = false;

  /**
   * ocr模式(1. 整份文件拍摄盖印 2. 单页拍摄盖印)
   * @type{Number}
   */
  ocrPattern = 2;

  /**
   * 是否存在补盖申请
   * @type{Boolean}
   */
  hasCover = false;

  /**
   * 印控仪未识别到设备关仓时间（秒）
   * @type{Number}
   */
  gateTime = 5;

  /**
   * 用印环境拍摄 (1、开启 2、关闭)
   * @type{Number}
   */
  deviceFace = 2;

  /**
   * 录视频  1、开启 2、关闭
   * @type{Number}
   */
  videoType = 2;

  /**
   * 印章识别 1、开启 2、关闭
   * @type{Number}
   */
  sealDiscern = 2;

  /**
   * 二维码水印 1、开启  2、关闭
   * @type{Number}
   */
  qrcodeType = 2;

  /**
   * 二维码渲染类型 1、单文件  2、单页
   * @type{Number}
   */
  qrcodePageType = 2;

  /**
   * 章筒拍摄视频 1开启 2关闭
   * @type{Number}
   */
  equipmentRec = 2;

  /**
   * 当前用印流程是否开启红外 1开启 2关闭
   * @type{Number}
   */
  infrared = 2;

  /**
   * 是否指纹认证  1:认证  2:不认证
   * @type{Number}
   */
  authentication = 1;

  /**
   * 补盖id
   * @type {number}
   */
  coverId = 0;


  /**
   * 是否拦截
   */
  hasIntercept;


  /**
   * 当前文件是否需要补拍
   */
  makeUpStatus;


  /**
   * 当前设备是否开启影像
   */
  pictureType;

  /**
   * 开启电子围栏
   */
  fence;

  /**
   *
   * @type{[{lat,lon,range}]}
   */
  geoFence = [];

  /**
   * 章筒拍摄整段视频  1、开启 2、关闭
   * @type {number}
   */
  equipmentRecVideoAllType = 2;

  /**
   * 章筒标记录制单次盖印视频 1、开启 2、关闭")
   * @type {number}
   */
  everyType = 2;

  /**
   * 章筒标记录制违规用印视频 1、开启 2、关闭")
   * @type {number}
   */
  riskType = 2;

  /**
   * 视频分割时间 单位分钟 默认30分钟
   * @type {number}
   */
  timeDivision = 30;

  /**
   * 防遮挡检测  1: 开启  2: 关闭
   * @type {number}
   */
  preventOcclusion = 2;

  /**
   * 空白页  1: 开启  2: 关闭
   * @type {number}
   */
  blankPage = 2;
  //内容一致性
  consistencyTesting = 2;

  /**
  * 清晰度检测  1: 开启  2: 关闭
  * @type {number}
  */
  imageAcuity = 2;

  _examineFinish = 2;

  bleMac;

  api;
  iot;

  consistencyTestingResults;

  get examineFinish() {
    return this.fullExamine ? this._examineFinish : 0;
  }

  set beforeSealPhoto(beforeSealPhoto) {
    this._beforeSealPhoto = beforeSealPhoto;
  }

  get beforeSealPhoto() {
    return this._beforeSealPhoto === 1 && !(this.fullExamine && this.examineFinish === 1) ? 1 : 2;
  }

  /**
   * 盖印前解析
   * @return {number}  1: 开启  2: 关闭
   */
  get parseBeforeStamping() {
    return (this.preventOcclusion === 1 || this.blankPage === 1 || this.imageAcuity === 1 || (this.consistencyTesting == 1 && (this.consistencyTestingResults || []).map(e => e['consistencyTestingResult'] || '').filter(e => e).length > 0)) ? 1 : 2;
  }

  get sealAuthentication() {
    return (this.isOpenOcr || this.qrcodeType === 1 || this.beforeSealPhoto === 1 || this.remote === 2 || this.afterSealSnap === 1) ? 1 : 2;
  }

  get deviceSealAuthentication() {
    return (this.sealAuthentication === 1 || this.sealDiscern === 1) ? 1 : 2;
  }

  get sealAuthenticationNotBefore() {
    return (this.isOpenOcr || this.qrcodeType === 1 || this.remote === 2) ? 1 : 2;
  }

  get fullExamine() {
    return (this.isOpenOcr && [1, 3, 4].includes(+this.ocrPattern))
      || (this.qrcodeType === 1 && this.qrcodePageType === 1)
  }

  /**
   * 是否需要盖印前检查
   * @return {number}   1: 开启  2: 关闭
   */
  get sealAuthenticationExamine() {
    return this.sealAuthenticationNotBefore === 1 && this.examineFinish !== 1 ? 1 : 2;
  }

  setExamineFinish() {
    this._examineFinish = 1;
  }

  clearExamine() {
    this._examineFinish = 2;
  }

  get mode() {
    if (this.remote === 1) {
      if (this.fullExamine) {
        //增加盖印后, 需要吧全量释放改成单次释放
        if (this.afterSealSnap === 1) {
          return 1;
        } else {
          return 2;
        }
      }
    } else if (this.remote === 3) {
      if ((this.isOpenOcr && [1, 3, 4].includes(+this.ocrPattern))
        || (this.qrcodeType === 1 && this.qrcodePageType === 1)
        || this.beforeSealPhoto === 1) {
        return 3;
      }
    }

    return 1;
  }

  get camera() {
    return this.sealAuthentication === 1 || this.videoType === 1 || (this.infrared === 2 && this.sealDiscern === 1);
  }
}

export { DeviceInfo, config, setConfig, Config, DeviceType };